module.exports = __webpack_public_path__ + "media/images/global/mwed_logo-8e87d7911ee67a4de02e44d865bec1f8.png";